import Link from "next/link"
import { ComponentProps } from "react"
import { twMerge } from "tailwind-merge"

type TextLinkProps = ComponentProps<typeof Link> & { showVisited?: boolean }

const TextLink: React.FC<TextLinkProps> = ({ className, showVisited = true, ...rest }) => (
  <Link
    className={twMerge(
      "text-purple hover:text-purple-800 underline",
      "text-[1rem] md:text-[1.125rem] font-medium leading-1.5",
      !showVisited ? "visited:text-purple" : "",
      "focus-visible:outline focus-visible:rounded-lg focus-visible:outline-2 focus-visible:outline-purple focus-visible:outline-offset-2 active:scale-95",
      className,
    )}
    {...rest}
  />
)

export default TextLink
